export default "__VITE_ASSET__BWzACdM0__"